/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q3Inputs */

const en_viewer_faq_q3 = /** @type {(inputs: Viewer_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the maximum JSON size supported?`)
};

const ko_viewer_faq_q3 = /** @type {(inputs: Viewer_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원되는 최대 JSON 크기는?`)
};

const ja_viewer_faq_q3 = /** @type {(inputs: Viewer_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートされる最大JSONサイズは？`)
};

/**
* | output |
* | --- |
* | "What is the maximum JSON size supported?" |
*
* @param {Viewer_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q3 = /** @type {((inputs?: Viewer_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q3(inputs)
	if (locale === "ko") return ko_viewer_faq_q3(inputs)
	return ja_viewer_faq_q3(inputs)
});